import { render, staticRenderFns } from "./PermissionEditDialog.vue?vue&type=template&id=ccd66abc&scoped=true"
import script from "./PermissionEditDialog.vue?vue&type=script&lang=js"
export * from "./PermissionEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd66abc",
  null
  
)

export default component.exports